import { FiArrowRight, FiBookOpen } from 'react-icons/fi'
import { Container, Reveal, HoverText } from '@/components/common'
import { actionClass } from '@/constants/magazine'
import magazineCover from '@/assets/images/magazine-feature.jpeg'

export const FeaturedIssue = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        {/* Cover */}
        <Reveal variant="right" className="order-last lg:order-first">
          <div className="relative overflow-hidden">
            <img
              src={magazineCover}
              alt="IBON World Magazine, featured issue"
              className="aspect-4/5 w-full object-cover transition-transform duration-700 hover:scale-105"
              loading="lazy"
            />
            <span className="absolute left-0 top-0 bg-ibon-sky px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark">
              Latest Issue
            </span>
          </div>
        </Reveal>

        {/* Text */}
        <div>
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Empowering Africa&apos;s <span className="text-ibon-dark/30">future.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 max-w-xl text-lg leading-relaxed text-text-muted">
              Explore our latest edition and discover inspiring stories, emerging trends, and voices
              that are creating impact across the regions we serve, from entrepreneurs and educators
              to cultural leaders and changemakers.
            </p>
          </Reveal>

          <Reveal variant="up" delay={300}>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <a
                href={magazineCover}
                target="_blank"
                rel="noopener noreferrer"
                className={actionClass.primary}
              >
                <HoverText text="Read the Latest Issue" />
                <FiArrowRight
                  className="transition-transform duration-300 group-hover:translate-x-1"
                  size={15}
                />
              </a>
              <a href="#archive" className={actionClass.outline}>
                <HoverText text="Explore the Magazine Archive" />
                <FiArrowRight
                  className="transition-transform duration-300 group-hover:translate-x-1"
                  size={15}
                />
              </a>
              <a href="#newsletter" className={actionClass.ghost}>
                <HoverText text="Subscribe for Updates" />
                <FiArrowRight
                  className="transition-transform duration-300 group-hover:translate-x-1"
                  size={15}
                />
              </a>
            </div>
          </Reveal>

          <Reveal variant="fade" delay={380}>
            <p className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-text-muted">
              <FiBookOpen size={14} />
              Available to read online, with new editions released every quarter.
            </p>
          </Reveal>
        </div>
      </Container>
    </section>
  )
}
